// Tasting Experience types for WineryXplorer
export const TASTING_EXPERIENCE_STATUS = ['draft', 'published', 'archived'];
/**
 * Price filter bands for tasting experiences, on `price.amount`. `max` is
 * exclusive; the last band is open-ended. Labels assume the amounts are
 * dollars, as every experience price is today.
 */
export const EXPERIENCE_PRICE_BANDS = [
    { key: 'under-25', label: 'Under $25', min: 0, max: 25 },
    { key: '25-50', label: '$25–$50', min: 25, max: 50 },
    { key: '50-100', label: '$50–$100', min: 50, max: 100 },
    { key: '100-plus', label: '$100+', min: 100, max: null },
];
